import React from 'react';
import styles from './key-information.module.scss';
import Markdown from 'markdown-to-jsx';

export type Props = {
  keyInfoTitle: string;
  keyInformationRichText: string;
};

export default function KeyInformation({ keyInfoTitle, keyInformationRichText }: Props) {
  return (
    <div className='row'>
      <div className='col-md-12'>
        {keyInformationRichText?.length ? (
          <>
            <h3 id='key-information' className={styles[`sub-title`]}>
              {keyInfoTitle}
            </h3>
            <section className={styles[`key-information`]}>
              <Markdown>{keyInformationRichText}</Markdown>
            </section>
          </>
        ) : null}
      </div>
    </div>
  );
}
